import React from 'react';
import {LikeCountButton} from '../../../../../components';
import {Button} from '../../../../../..';
import styles from './ResourceButtons.module.scss';
import useMusicContextMenu from '../../../../../../../hooks/useMusicContextMenu';

interface Props {
  id: string;
  onPlay(): void;
  likes: number;
  liked: boolean;
}

export function ResourceButtons({id, likes, onPlay, liked}: Props) {
  // Popover only works with library-album for now, need to clean up ResourceType code
  const {Popover, popoverProps, onContextMenu} = useMusicContextMenu({
    id: id,
    resourceType: 'library-album',
  });

  return (
    <div className={styles.Buttons}>
      <Button primaryBackground large onClick={onPlay}>
        Play
      </Button>
      <LikeCountButton large likes={likes} liked={false} />
      <Popover {...popoverProps}>
        <Button large onClick={onContextMenu}>
          ...
        </Button>
      </Popover>
    </div>
  );
}
